if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      static initCalled = false; // Static property to track if init() has been called

      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Check if init() has already been called
        if (!ProductForm.initCalled) {
          this.init();
          ProductForm.initCalled = true; // Set the flag to true after the first call
        }
      }

      init() {
        if (document.getElementById('spare-parts-form')) {
          document.getElementById('spare-parts-form').addEventListener('submit', function (e) {
            e.stopPropagation();
            e.preventDefault();
            const uniqueNumber = Date.now();
            const productVariantId = qs('#spare-parts-form .product-variant-id').value;
            const uniqueBundleId = 'bundle_' + uniqueNumber + '_' + productVariantId;

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            // formData.append('items[0][id]', productVariantId);
            // formData.append('items[0][quantity]', 1);
            // formData.append('items[0][properties][bundle_id]', uniqueBundleId);

            const selectedSpareParts = document.querySelectorAll('.product-checkbox:checked');
            if (selectedSpareParts.length > 0) {
              formData.append('properties[bundle_id]', uniqueBundleId);
              selectedSpareParts.forEach((checkbox, index) => {
                const sparePartVariantId = checkbox.value;
                formData.append(`items[${index + 1}][id]`, sparePartVariantId);
                formData.append(`items[${index + 1}][quantity]`, 1);
                // formData.append(`items[${index + 1}][properties][bundle_id_spare_part]`, uniqueBundleId);
              });
            }
            this.cart = qs(".drawer");
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });

                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });
                this.cart.renderContents(response);
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                const sparePartContent = document.querySelector('.spare-part-content');
                sparePartContent.classList.remove('spare-part-active');
              }
              );
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const uniqueNumber = Date.now();
        const productVariantId = this.form.querySelector('.product-variant-id').value;
        const uniqueBundleId = 'bundle_' + uniqueNumber + '_' + productVariantId;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const checkbox = qs('.installation-services #checkbox1');
        if (checkbox && checkbox.checked) {
          formData.append('properties[bundle_id]', uniqueBundleId);
          const installationVariantId = checkbox.closest('.installation-services').getAttribute('data-var');
          formData.append('items[1][id]', installationVariantId);
          formData.append('items[1][quantity]', parseInt(qs(".product-form__buttons quantity-input .quantity__input").value));
          formData.append('items[1][properties][bundle_id_installation]', uniqueBundleId);
        }


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            //Installation item check
            const checkbox = document.getElementById('checkbox1');
            if (checkbox && checkbox.checked) {

              const dataVarAttribute = checkbox.closest('.installation-services').getAttribute('data-var');
              // addToCart(dataVarAttribute, uniqueBundleId);
            }
            this.submitButton.classList.add('added');
            setTimeout(() => {
              this.submitButton.classList.remove('added');
            }, 15000);
            setTimeout(() => {
              let cartCountElem = qs('.cart-count');
              let cartContainer = qs('.realtive_li.cart');

              if (cartContainer) {
                if (cartCountElem) {
                  let count = cartCountElem.textContent.replace(')', '').replace('(', '');
                  cartContainer.innerHTML = `
                    <a class="icons-links" id="cart-icon-bubble" role="button" aria-haspopup="dialog">
                      <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                        <path fill="currentColor" fill-rule="evenodd" d="m15.84,10.8l1.28-4.56H5.26l1.28,4.56c.08.29.25.54.48.71.22.17.51.27.81.27h6.73c.31,0,.59-.1.81-.27.22-.17.39-.41.48-.71h0Zm-1.29,2.57c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51Zm-7.24-1.02c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51ZM4.33,5.92l-.2-.73c-.08-.29-.25-.54-.48-.71-.22-.17-.51-.27-.81-.27h-1.31c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h1.31c.49,0,.93.16,1.3.43.36.27.63.67.77,1.13l.13.46h12.62s.07,0,.11.02c.21.06.34.28.28.5l-1.42,5.07c-.13.47-.4.86-.77,1.13-.36.27-.81.43-1.3.43h-6.73c-.49,0-.93-.16-1.3-.43-.36-.27-.63-.66-.77-1.13l-1.42-5.04s-.01-.03-.01-.05h0Z"></path>
                      </svg>
                      <span class="visually-hidden">Cart</span>
                      <p class="cart-count-bubble">
                        <span aria-hidden="true">${count}</span>
                        <span class="visually-hidden">${count} item</span>
                      </p>
                    </a>
                    <p class="icon_para">CART</p>
                  `;
                } else {
                  cartContainer.innerHTML = `
                    <a class="icons-links" id="cart-icon-bubble" role="button" aria-haspopup="dialog">
                      <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                        <path fill="currentColor" fill-rule="evenodd" d="m15.84,10.8l1.28-4.56H5.26l1.28,4.56c.08.29.25.54.48.71.22.17.51.27.81.27h6.73c.31,0,.59-.1.81-.27.22-.17.39-.41.48-.71h0Zm-1.29,2.57c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51Zm-7.24-1.02c.42,0,.8.17,1.08.45.28.28.45.66.45,1.08s-.17.8-.45,1.08c-.28.28-.66.45-1.08.45s-.8-.17-1.08-.45c-.28-.28-.45-.66-.45-1.08s.17-.8.45-1.08c.28-.28.66-.45,1.08-.45Zm.51,1.02c-.13-.13-.31-.21-.51-.21s-.38.08-.51.21c-.13.13-.21.31-.21.51s.08.38.21.51c.13.13.31.21.51.21s.38-.08.51-.21c.13-.13.21-.31.21-.51s-.08-.38-.21-.51ZM4.33,5.92l-.2-.73c-.08-.29-.25-.54-.48-.71-.22-.17-.51-.27-.81-.27h-1.31c-.22,0-.4-.18-.4-.4s.18-.4.4-.4h1.31c.49,0,.93.16,1.3.43.36.27.63.67.77,1.13l.13.46h12.62s.07,0,.11.02c.21.06.34.28.28.5l-1.42,5.07c-.13.47-.4.86-.77,1.13-.36.27-.81.43-1.3.43h-6.73c-.49,0-.93-.16-1.3-.43-.36-.27-.63-.66-.77-1.13l-1.42-5.04s-.01-.03-.01-.05h0Z"></path>
                      </svg>
                      <span class="visually-hidden">Cart</span>
                    </a>
                    <p class="icon_para">CART</p>
                  `;
                }
              }
            }, 1000);

          }
          );
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
